import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 500 501",
  "content": "<symbol viewBox=\"0 0 500 501\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\"><title>icon-search</title><g transform=\"translate(49 69)\" stroke=\"currentColor\" stroke-width=\"15.385\" fill=\"none\" fill-rule=\"evenodd\"><ellipse cx=\"153.846\" cy=\"153.913\" rx=\"153.846\" ry=\"153.913\" /><path d=\"M285.714 245.282l108.099 108.145\" stroke-linecap=\"square\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol